import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './PaymentProof.css';

const PaymentProof: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);

  // Mock course data
  const course = {
    id: 1,
    title: 'Advanced Mathematics',
    price: 49,
    tax: 4.9,
    total: 53.9
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = () => {
    if (selectedFile) {
      // Submit payment proof logic
      console.log('Submitting payment proof', { file: selectedFile, courseId: id });
      navigate(`/payment/${id}/status`);
    }
  };

  return (
    <div className="payment-proof-page">
      <header className="payment-proof-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          ←
        </button>
        <h1>Upload Payment Proof</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="payment-proof-content">
        {/* Course Info */}
        <div className="course-summary-card">
          <h3 className="card-title">Course Details</h3>
          <div className="course-info-row">
            <span className="info-label">Course:</span>
            <span className="info-value">{course.title}</span>
          </div>
          <div className="course-info-row">
            <span className="info-label">Price:</span>
            <span className="info-value">${course.price}</span>
          </div>
          <div className="course-info-row">
            <span className="info-label">Tax:</span>
            <span className="info-value">${course.tax}</span>
          </div>
          <div className="course-info-row total-row">
            <span className="info-label">Total:</span>
            <span className="info-value total-amount">${course.total}</span>
          </div>
        </div>

        {/* Upload Section */}
        <div className="upload-section">
          <h3 className="card-title">Upload Payment Receipt</h3>
          <p className="upload-instructions">
            Please upload a clear photo or screenshot of your payment receipt (bank transfer, payment confirmation, etc.)
          </p>

          <div className="upload-area">
            {preview ? (
              <div className="preview-container">
                <img src={preview} alt="Preview" className="preview-image" />
                <button 
                  className="remove-image-button"
                  onClick={() => {
                    setSelectedFile(null);
                    setPreview(null);
                  }}
                >
                  ✕ Remove
                </button>
              </div>
            ) : (
              <label className="upload-label">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="file-input"
                />
                <div className="upload-placeholder">
                  <div className="upload-icon">📷</div>
                  <p className="upload-text">Tap to upload image</p>
                  <p className="upload-hint">JPG, PNG up to 5MB</p>
                </div>
              </label>
            )}
          </div>

          {selectedFile && (
            <div className="file-info">
              <span className="file-name">📄 {selectedFile.name}</span>
              <span className="file-size">{(selectedFile.size / 1024 / 1024).toFixed(2)} MB</span>
            </div>
          )}
        </div>

        {/* Payment Instructions */}
        <div className="instructions-card">
          <h3 className="card-title">Payment Instructions</h3>
          <ol className="instructions-list">
            <li>Complete your payment via bank transfer or other payment method</li>
            <li>Take a clear photo or screenshot of the payment receipt</li>
            <li>Upload the receipt using the button above</li>
            <li>Wait for admin approval (usually within 24 hours)</li>
            <li>You'll receive a notification once approved</li>
          </ol>
        </div>

        {/* Submit Button */}
        <button
          className={`submit-proof-button ${selectedFile ? 'active' : ''}`}
          onClick={handleSubmit}
          disabled={!selectedFile}
        >
          Submit Payment Proof
        </button>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default PaymentProof;
